import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CTAFinalSection = () => {
  return (
    <section
      id="cta-final"
      data-testid="cta-final-section"
      className="py-20 md:py-28 bg-forest text-white"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-white mb-6"
            data-testid="cta-final-headline"
          >
            Vous possédez une forêt ou une parcelle boisée ?
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mb-8" />
          <p className="font-sans text-base md:text-lg text-white/80 leading-relaxed mb-10 max-w-3xl mx-auto">
            Que vous souhaitiez connaître sa valeur, vendre, valoriser vos bois, sortir d'une indivision ou regrouper votre foncier, Sylva Invest peut analyser votre situation et vous orienter vers la solution adaptée.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/estimation-foret"
              className="btn-primary bg-gold text-forest hover:bg-white hover:text-forest"
              data-testid="cta-final-primary"
            >
              Estimer ma forêt
            </Link>
            <a
              href="#contact"
              className="btn-primary bg-transparent border-2 border-white text-white hover:bg-white hover:text-forest"
              data-testid="cta-final-secondary"
            >
              Nous contacter
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTAFinalSection;
